// AuthContext.js
import React, { createContext, useState, useEffect } from "react";


export const DatosNutriologoContext = createContext();

export const DatosNutriologoContextProvider = ({ children }) => {
    
    const [loading, setLoading] = useState(false);
    const [datosNutriologo, setDatosNutriologo] = useState(null);
    const [errorSubdominio, setErrorSubdominio] = useState(null);

    const obtenerDatosNutriologoPorSD = async () => {
        try {
          const hostname = window.location.hostname;
          const subdominio = hostname.split(".")[0];
    
          if (!subdominio) {
            throw new Error("No se pudo determinar el subdominio.");
          }
    
          const response = await fetch(
            `/api/nutriologo/subdomain/info?subdominio=${subdominio}`
          );
          if (!response.ok) {
            throw new Error("Error al obtener los datos del backend");
          }
    
          const result = await response.json();
          setDatosNutriologo(result);
        } catch (err) {
          setErrorSubdominio(err.message);
        } finally {
          setLoading(false);
        }
    };



  return (
    <DatosNutriologoContext.Provider value={{ datosNutriologo, setDatosNutriologo, loading, setLoading, errorSubdominio, setErrorSubdominio, obtenerDatosNutriologoPorSD }}>
      {children}
    </DatosNutriologoContext.Provider>
  );
};
